import React, { ReactNode } from 'react'

interface Props {
    className?: string
}

/**
 * Pretty (non-emoji) success mark shown next to the done message once every top-level task has
 * reached a terminal state. A soft, dimmed green filled circle with a rounded checkmark, sized to
 * match the 1rem task status icons.
 */
export const TasksProgressionDoneIcon = ({ className = '' }: Props): ReactNode => {
    return (
        <span
            aria-hidden="true"
            className={`inline-flex h-4 w-4 shrink-0 items-center justify-center ${className}`}
            data-testid="tasks-progression-done-icon"
        >
            <svg viewBox="0 0 16 16" className="h-4 w-4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="8" className="fill-success-600/20" />
                <path
                    d="M5 8.25L7 10.25L11 6"
                    className="stroke-success-600"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
